import { PropsWithChildren, useEffect, useRef } from 'react';
import * as S from './styles';
import { Tamanho } from '@/components/templates/Drawer';

export type AccordionSize = 1 | 2 | 3 | 4;
export type AccordionStyle =
  | 'solid'
  | 'bordered'
  | 'ghost'
  | 'separate'
  | 'translucent';

export type AccordionProps = PropsWithChildren<{
  $size: AccordionSize;
  $style: AccordionStyle;
  // eslint-disable-next-line no-unused-vars
  $lidarMudancaTamanho?: (tamanho: Tamanho) => void;
}>;

export default function Accordion(props: AccordionProps) {
  const { $size, $style, children, $lidarMudancaTamanho } = props;
  const accordionRef = useRef(null);

  useEffect(() => {
    const mudancaValorTamanho = () => {
      if (accordionRef?.current) {
        const { offsetWidth, offsetHeight } = accordionRef.current;
        const newSize = { width: offsetWidth, height: offsetHeight };
        if ($lidarMudancaTamanho) {
          $lidarMudancaTamanho(newSize);
        }
      }
    };

    const mudancaTamanhoObserver = new ResizeObserver(mudancaValorTamanho);
    if (accordionRef?.current) {
      mudancaTamanhoObserver.observe(accordionRef.current);
    }

    return () => {
      mudancaTamanhoObserver.disconnect();
    };
  }, [$lidarMudancaTamanho]);

  return (
    <S.Container ref={accordionRef} $size={$size} $style={$style}>
      {children}
    </S.Container>
  );
}
